import * as React from 'react';
import { SVGProps } from 'react';

const IconRulerFilledSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M1 3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H9v2H8V3H6v3H5V3H3v2H2V3H1Z" />
  </svg>
);
export default IconRulerFilledSizeXs;
